module.exports = __webpack_public_path__ + "static/media/road.abe96e6b.svg";